export default {"src":"/_next/static/media/lifebuoy100_40.85f8501f.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};